var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronUp = function SvgChevronUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7149 8.9186L11.1374 9.49634C10.9372 9.68626 10.7035 9.78125 10.4366 9.78125C10.1643 9.78125 9.93333 9.68626 9.74333 9.49634L6.00001 5.75292L2.25673 9.49624C2.06676 9.68616 1.83572 9.78114 1.56349 9.78114C1.29653 9.78114 1.06282 9.68616 0.862652 9.49624L0.292676 8.91849C0.0975228 8.72347 0 8.48977 0 8.21759C0 7.94035 0.0976307 7.70929 0.292649 7.52447L5.30675 2.51034C5.49168 2.31529 5.72263 2.21769 5.99999 2.21769C6.27213 2.21769 6.50581 2.31526 6.70078 2.51034L11.7149 7.52447C11.9049 7.71449 12 7.94553 12 8.21759C12 8.4847 11.9049 8.71826 11.7149 8.9186Z",
    fill: "#124B88"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevronUp.01e8705d.svg";
export { ForwardRef as ReactComponent };